import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';

@Pipe({
  name: 'markdown',
  standalone: true,
})
export class MarkdownPipe implements PipeTransform {
  readonly #sanitizer = inject(DomSanitizer);

  public transform(value: string) {
    if (!value) {
      return '';
    }

    const renderer = new marked.Renderer();

    renderer.heading = (text, level) => `<p class="h${level} mb-2">${text}</p>`;
    renderer.paragraph = (text) => `<p class="mb-2">${text}</p>`;
    renderer.blockquote = (text) => `<blockquote>${text}</blockquote>`;
    renderer.list = (body) => `<ul class="mb-2">${body}</ul>`;
    renderer.link = (href, _title, text) => {
      href = href.replace('zeroapp://', '');
      return `<span class="link-secondary text-default cursor-pointer" onclick="window.open('${href}', '_blank')">${text}</span>`;
    };
    marked.setOptions({ renderer });

    const markdownHtml = marked(value, { async: false }) as string;
    return this.#sanitizer.bypassSecurityTrustHtml(markdownHtml);
  }
}
